module.exports = __webpack_public_path__ + "static/media/CNN 解释器(层计算过程.469b6d97.png";